export const headerName = {
  add: "Добавить участок",
  edit: "Редактировать участок",
};
export const gimsSectionsData = {
  sctName: {
    key: "sctName",
    label: "Название участка",
    type: "text",
    required: true,
  },
  depId: {
    key: "depId",
    label: "Наименование структурного подразделения",
    type: "selectSearch",
    placeholder: "Выберите",
    isSearchable: true,
    required: true,
    options: [],
  },
  dateStart: {
    key: "dateStart",
    label: "Дата начала действия",
    type: "date",
    required: true,
  },
  dateEnd: {
    key: "dateEnd",
    label: "Дата окончания  действия",
    type: "date",
  },
  sctNote: {
    key: "sctNote",
    label: "Описание участка",
    type: "text",
  },
};

export const gimsSectionsEditData = {
  sctName: {
    key: "sctName",
    label: "Название участка",
    type: "text",
    disabled: true,
  },
  depId: {
    key: "depId",
    label: "Наименование структурного подразделения",
    type: "selectSearch",
    placeholder: "Выберите",
    isSearchable: true,
    isDisabled: true,
    options: [],
  },
  dateEnd: {
    key: "dateEnd",
    label: "Дата окончания  действия",
    type: "date",
    required: true,
  },
};

export const setDepIdOptions = (data) => {
  if (gimsSectionsData.depId.options.length === 0) gimsSectionsData.depId.options = data;

  if (gimsSectionsEditData.depId.options.length === 0) gimsSectionsEditData.depId.options = data;
};

export const getGimsSectionsDataModal = () => gimsSectionsData;
export const getGimsSectionsEditDataModal = () => gimsSectionsEditData;
